import NavLink from 'next/link';
import {useRouter} from 'next/router';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import {pathOr} from 'ramda';
import {useCallback, useRef, useState} from 'react';

import ZoomIcon from '@/public/icons/zoom.svg';
import {SB_SEARCH_QUERY} from '@/src/howTo/constants/search';
import {Text} from '@/src/ui';

import css from '../../styles/SearchField.module.css';

const Search = ({onChange, foundedItems, onSearchSubmit, title}) => {
  const {query} = useRouter();
  const {t} = useTranslation('common');

  const [isFocus, setIsFocus] = useState(false);
  const [isHover, setIsHover] = useState(false);

  const inputRef = useRef();

  const setFocus = useCallback(() => {
    setIsFocus(true);
  }, []);

  const removeFocus = useCallback(() => {
    setIsFocus(false);
  }, []);

  const queryValue = pathOr('', ['current', 'value'], inputRef);

  return (
    <div className={css.searchWrapper}>
      <div className={css.title}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontFamily={Text.FONT_FAMILY.POPPINS}
          fontWeight={Text.FONT_WEIGHT.BOLD}
          tagComponent={Text.TAG.H1}
        >
          {title}
        </Text>
      </div>
      <div className={css.searchOffset}>
        <form
          className={css.search}
          onSubmit={onSearchSubmit}
          autoComplete="none"
        >
          <button className={css.searchIcon} type="submit">
            <ZoomIcon />
          </button>
          <input
            ref={inputRef}
            type="text"
            name="search"
            defaultValue={query[SB_SEARCH_QUERY.SEARCH_TERMS] || ''}
            onChange={onChange}
            className={css.searchInput}
            onFocus={setFocus}
            onBlur={removeFocus}
            placeholder={t('general.search')}
          />
          {(isFocus || isHover) && Boolean(foundedItems.length) && (
            <ul
              className={css.foundedList}
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
            >
              {foundedItems.map((item) => {
                return (
                  <li className={css.foundedListItem} key={item.href}>
                    <NavLink
                      href={{
                        pathname: `/${item.href}`,
                        query: {
                          [SB_SEARCH_QUERY.SEARCH_TERMS]: queryValue,
                        },
                      }}
                    >
                      <a>
                        <Text
                          fontSize={Text.FONT_SIZE.SIZE_14}
                          fontWeight={Text.FONT_WEIGHT.BOLD}
                          color={Text.COLOR.PRIMARY}
                          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
                        >
                          {item.title}
                        </Text>
                        <Text
                          fontSize={Text.FONT_SIZE.SIZE_14}
                          color={Text.COLOR.SECONDARY}
                          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
                        >
                          {item.text}
                        </Text>
                      </a>
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          )}
        </form>
      </div>
    </div>
  );
};

Search.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
  foundedItems: PropTypes.array.isRequired,
};

export default Search;
